import styled from 'styled-components';

export const RobePath = styled.path`
  fill: #050505;
`;

export const InnerRobePath = styled.path`
  fill: url(#linear-gradient);
`;
